<template>
  <div class="c-accordion">
    <transition name="u-fade">
      <div class="c-accordion__content" v-show="isOpen">
        <slot></slot>
      </div>
    </transition>
    <div class="c-accordion__controls">
      <button
        class="c-accordion__button"
        v-bind:class="[isOpen ? activeClass : 'is-active']"
        v-on:click.prevent="toggleContent"
      >
        <svg
          class="c-accordion__icon"
          v-bind:class="[isOpen ? activeClass : 'is-active']"
          width="40"
          height="12"
        >
          <polyline points="12,2 20,10 28,2" stroke-width="3" fill="none" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeClass: "",
      isOpen: true
    };
  },
  methods: {
    toggleContent: function() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>